import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import css from './Ruble.module.scss'
import bem from 'bem'
import { numberFormat } from 'utils/numberFormat'

const b = bem.ruble(css)

const Ruble = ({ children }) => (
	<Fragment>
		{children && numberFormat(children)}
		<span className={b()}>Р</span>
	</Fragment>
)

Ruble.propTypes = {
	children: PropTypes.number,
}

export default Ruble
